/* Navbar scroll behaviour — ported from
 * orion-v3.0/src/js/navbar.js.
 *
 * v3.0 used jQuery + lodash.debounce; H3.0 swaps both for vanilla:
 * a `requestAnimationFrame` throttle around the scroll listener and
 * direct DOM class toggling on document.body.
 *
 * Body classes toggled:
 *   navbar--scrolled  — set once the page has scrolled past
 *                       SCROLL_OFFSET. Drives the colour-scheme
 *                       switch (transparent → light) in
 *                       navbar-colors.liquid.
 *   scrolled-down     — set while the user is actively scrolling
 *                       down. Combined with .navbar--scrolled and
 *                       the absence of .navbar--always-show /
 *                       .navbar--show-megamenu / .navbar--show-
 *                       mobile-menu, this slides the navbar up out
 *                       of view (CSS rule in component-navbar.css).
 *
 * `navbar--always-show` is set by the inline `<script>` in
 * sections/header.liquid when the merchant has Hide on Scroll
 * disabled — we don't touch it here. */

const SCROLL_OFFSET = 200;

class NavbarScrollController {
  constructor() {
    this.lastScrollTop = 0;
    this.ticking = false;
    this.handleScroll = this.handleScroll.bind(this);
    this.onScroll = this.onScroll.bind(this);
  }

  init() {
    this.update();
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(this.handleScroll);
  }

  handleScroll() {
    this.update();
    this.ticking = false;
  }

  update() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const body = document.body;

    body.classList.toggle('navbar--scrolled', scrollTop > SCROLL_OFFSET);
    body.classList.toggle('scrolled-down', scrollTop > SCROLL_OFFSET && scrollTop > this.lastScrollTop);

    this.lastScrollTop = scrollTop;
  }
}

function start() {
  new NavbarScrollController().init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
